import { useState } from 'react'
import { Editable } from 'apps/studio/components/shared/inputs/EditableLabel'
import { FieldIcon } from 'apps/studio/components/shared/FieldIcon'
import { useTransformWrapper } from 'apps/studio/contexts/TransformWrapperContext'
import {
  PageIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  MobileIcon,
  TableIcon,
} from '@gocanvas/gcds/icons'

export const OutlineItem = ({
  type,
  label,
  isActive,
  setIsActive,
  editable = false,
  updateLabel = () => {},
  pageNumber,
}) => {
  const { scrollToPage } = useTransformWrapper()

  return (
    <li
      className="outline--item"
      role="button"
      tabIndex={0}
      aria-pressed={isActive}
      onClick={e => {
        e.stopPropagation()
        setIsActive()
      }}
      onDoubleClick={scrollToPage(pageNumber)}
    >
      <div
        className={`gcds--item item--condensed item--scroll-x ${
          isActive ? 'is-selected' : ''
        }`}
      >
        <div className="item--icon">
          <FieldIcon type={type} className="outline--field-icon" />
        </div>
        {editable ? (
          <Editable
            className="item--label"
            value={label}
            update={newLabel => updateLabel(newLabel)}
          />
        ) : (
          <span className="item--label">{label}</span>
        )}
      </div>
    </li>
  )
}

const OUTLINE_GROUP_ICONS = {
  page: PageIcon,
  screen: MobileIcon,
  table: TableIcon,
}

export const OutlineGroup = ({
  title,
  isActive,
  setIsActive,
  type,
  children,
  editable = false,
  shouldDisplayGroup = false,
  updateTitle = () => {},
  pageNumber,
}) => {
  const [isOpen, setIsOpen] = useState(true)
  const { scrollToPage } = useTransformWrapper()
  const Icon = OUTLINE_GROUP_ICONS[type]
  const open = shouldDisplayGroup ? false : isOpen

  // Still render Icon when no group icon matches
  const renderIcon = () =>
    Icon ? (
      <Icon className="outline--group-icon" />
    ) : (
      <FieldIcon type={type} className="outline--field-icon" />
    )

  return (
    <div className="gcds--outline --outline--group--container">
      <ol className={`outline--list`}>
        <li className="outline--item">
          <div
            className={`gcds--item item--condensed item--scroll-x ${
              isActive ? 'is-selected' : ''
            }`}
            role="button"
            tabIndex={0}
            aria-pressed={isActive}
            onClick={() => setIsActive()}
            onDoubleClick={() => scrollToPage(pageNumber)}
          >
            <div
              className="item--icon toggle--icon"
              aria-label={isOpen ? `Collapse ${type}` : `Expand ${type}`}
              onClick={() => {
                if (!shouldDisplayGroup) {
                  setIsOpen(!isOpen)
                }
              }}
            >
              {open ? <ChevronDownIcon /> : <ChevronRightIcon />}
            </div>
            <div className="item--icon">{renderIcon()}</div>
            {editable ? (
              <Editable
                className="item--label"
                value={title}
                update={newTitle => updateTitle(newTitle)}
              />
            ) : (
              <span className="item--label">{title}</span>
            )}
          </div>
          {open && (
            <ol className="outline--list">
              {children ? (
                children
              ) : (
                <li className="outline--item">
                  <div className="gcds--item item--condensed outline--empty-message">
                    <div className="item--label">{`This ${type} is empty`}</div>
                  </div>
                </li>
              )}
            </ol>
          )}
        </li>
      </ol>
    </div>
  )
}
